import { LanguageProvider } from '@/contexts/LanguageContext';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import CustomCursor from '@/components/CustomCursor';
import PlaygroundSection from '@/components/sections/PlaygroundSection';
import ROICalculatorSection from '@/components/sections/ROICalculatorSection';
import ConfiguratorSection from '@/components/sections/ConfiguratorSection';
import FinalCTASection from '@/components/sections/FinalCTASection';
import AlexChat from '@/components/AlexChat';

const ExperienceLab = () => {
  return (
    <LanguageProvider>
      <CustomCursor />
      <Navbar />
      <main className="experience-lab">
        <PlaygroundSection />
        <ROICalculatorSection />
        <ConfiguratorSection />
        <FinalCTASection />
      </main>
      <Footer />
      <AlexChat />
    </LanguageProvider>
  );
};

export default ExperienceLab;
